import {
  DEFAULT_BEHAVIOUR,
  DEFAULT_PERSONALITY,
  DEFAULT_ROLE,
} from '../../../constants/defaults';
import {
  disclaimerMessageReferencesAdapter,
  greetingReferencesAdapter,
  languageBehaviorReferencesAdapter,
  personalityReferencesAdapter,
  rolesReferencesAdapter,
  rulesReferencesAdapter,
} from './adapters';
import type {
  DeprecatedAgentSettings,
  DisclaimerMessage,
  Greeting,
  LanguageBehavior,
  Personality,
  Role,
  Rules,
} from './types';

const DEFAULT_ADJECTIVES = DEFAULT_PERSONALITY.adjectives;

export const DEFAULT_RULES: Rules = {
  behaviour: DEFAULT_BEHAVIOUR,
  references: rulesReferencesAdapter.createInitialState(),
  createdBy: 'system',
  createdAt: '',
  updatedAt: '',
  updatedBy: '',
};

export const DEFAULT_GREETING: Greeting = {
  welcomeMessage: '',
  createdAt: '',
  createdBy: 'system',
  updatedAt: '',
  updatedBy: '',
  references: greetingReferencesAdapter.createInitialState(),
  languageCode: 'en-GB',
};

export const DEFAULT_DISCLAIMER_MESSAGE: DisclaimerMessage = {
  isEnabled: false,
  message: '',
  ringingTone: {
    s3Path: '',
    originalFilename: '',
    publicUrl: '',
  },
  createdAt: '',
  createdBy: 'system',
  updatedAt: '',
  updatedBy: '',
  languageCode: '',
  references: disclaimerMessageReferencesAdapter.createInitialState(),
};

export const PERSONALITY_INITIAL_STATE: Personality = {
  adjectives: DEFAULT_ADJECTIVES,
  custom: '',
  createdAt: '',
  createdBy: 'system',
  updatedAt: '',
  updatedBy: '',
  references: personalityReferencesAdapter.createInitialState(),
};

export const RULES_INITIAL_STATE: Rules = {
  behaviour: DEFAULT_BEHAVIOUR,
  references: rulesReferencesAdapter.createInitialState(),
  createdBy: 'system',
  createdAt: '',
  updatedAt: '',
  updatedBy: '',
};

export const ROLE_INITIAL_STATE: Role = {
  value: DEFAULT_ROLE.value,
  additionalInfo: DEFAULT_ROLE.additional_info,
  custom: '',
  createdAt: '',
  createdBy: 'system',
  updatedAt: '',
  updatedBy: '',
  references: rolesReferencesAdapter.createInitialState(),
};

export const DEFAULT_LANGUAGE_BEHAVIOR: LanguageBehavior = {
  behaviorPrompt: '',
  languageCode: '',
  createdBy: 'system',
  createdAt: '',
  updatedAt: '',
  updatedBy: '',
  references: languageBehaviorReferencesAdapter.createInitialState(),
};

// Default language code to use for greetings, disclaimer messages to carry out the migration for already existing data
export const DEFAULT_AGENT_SETTINGS_LANGUAGE_CODE = 'en-GB';

export const DEFAULT_WELCOME_MESSAGE = 'Hi! How can I help you today?';

export const DEPRECATED_INITIAL_STATE: DeprecatedAgentSettings = {
  greeting: {
    welcomeMessage: '',
    createdAt: '',
    createdBy: 'system',
    updatedAt: '',
    updatedBy: '',
    references: greetingReferencesAdapter.createInitialState(),
  },
  disclaimerMessage: {
    isEnabled: false,
    message: '',
    ringingTone: {
      s3Path: '',
      originalFilename: '',
      publicUrl: '',
    },
    createdAt: '',
    createdBy: 'system',
    updatedAt: '',
    updatedBy: '',
    references: disclaimerMessageReferencesAdapter.createInitialState(),
  },
  personality: {
    adjectives: DEFAULT_ADJECTIVES,
    custom: '',
    createdAt: '',
    createdBy: 'system',
    updatedAt: '',
    updatedBy: '',
    references: personalityReferencesAdapter.createInitialState(),
  },
  role: {
    value: DEFAULT_ROLE.value,
    additionalInfo: DEFAULT_ROLE.additional_info,
    custom: '',
    createdAt: '',
    createdBy: 'system',
    updatedAt: '',
    updatedBy: '',
    references: rolesReferencesAdapter.createInitialState(),
  },
  rules: {
    behaviour: DEFAULT_BEHAVIOUR,
    references: rulesReferencesAdapter.createInitialState(),
    createdBy: 'system',
    createdAt: '',
    updatedAt: '',
    updatedBy: '',
  },
};
